import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  activateStaff,
  deactivateStaff,
} from "../../../redux/slice/staff/staffSlice";

const ActivateAndDeactivateStaff = () => {
  const { staff_information } = useSelector((state) => state.staff);

  const dispatch = useDispatch();

  const handleSubmit = () => {
    if (staff_information?.personal_information.active !== "1") {
      dispatch(
        activateStaff({ id: staff_information?.personal_information?.id })
      );
    } else {
      dispatch(
        deactivateStaff({ id: staff_information?.personal_information?.id })
      );
    }
  };

  return (
    <div className='mt-3'>
      <button
        className={`btn btn-sm ${
          staff_information?.personal_information?.active !== "1"
            ? "btn-success"
            : "btn-warning"
        } text-white`}
        onClick={handleSubmit}
      >
        {staff_information?.personal_information?.active === "1"
          ? "Deactivate Staff"
          : "Activate Staff"}
      </button>
    </div>
  );
};

export default ActivateAndDeactivateStaff;
